import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(duration);
dayjs.extend(customParseFormat);

export const isPlural = (numb: number) => {
  return numb > 1 ? 's' : '';
};

export const dateToDuration = (
  date: Date | number | string,
  isV2 = false
): string => {
  let mDate = dayjs(date);
  if (typeof date === 'number') {
    mDate = dayjs(date);
  } else if (typeof date === 'string') {
    mDate = dayjs(date, 'YYYY-MM-DD HH:mm:ss');
  }
  const dateToday = dayjs(new Date());
  const durationDate = dayjs.duration(dateToday.diff(mDate));
  const years = durationDate.years();
  const months = durationDate.months();
  const weeks = durationDate.weeks();
  const days = durationDate.days();
  const hours = durationDate.hours();
  const minutes = durationDate.minutes();
  const seconds = durationDate.seconds();

  if (isV2) {
    return years
      ? `${years} year${isPlural(years)} ago`
      : months
      ? `${months} month${isPlural(months)} ago`
      : weeks
      ? `${weeks} week${isPlural(weeks)} ago`
      : days
      ? `${days} day${isPlural(days)} ago`
      : `today`;
  }
  return months
    ? `${months} month${isPlural(months)} ago`
    : weeks
    ? `${weeks} week${isPlural(weeks)} ago`
    : days
    ? `${days} day${isPlural(days)} ago`
    : hours
    ? `${hours} hour${isPlural(hours)} ago`
    : minutes
    ? `${minutes} minute${isPlural(minutes)} ago`
    : `${seconds} second${isPlural(minutes)} ago`;
};
